export default __webpack_public_path__ + "f06357221de7560d97a0d6b664fdd5fa.wav";